import { BookingType } from "../../../features/Booking-Form/typings/booking-inputs";
import { TeamMember } from "../../../features/Booking-Form/typings/team-member";
import { postVisitorGroupBooking } from "../../../hooks/Remote/Schedule/visitor-group-booking.api";
import { PlaceBookingDto } from "../../../features/Booking-Form/typings/booking.types";
import { BookingStrategyContext } from "./bookingStrategies";

type BuildPlaceBookingPayloadOptions = {
  automatedSeating?: boolean;
  /** When set, overrides `inputs.selectedLocation` (required for visit-only bookings). */
  locationInventoryId?: number | null;
};

export const buildPlaceBookingPayload = (
  ctx: BookingStrategyContext,
  users: TeamMember[],
  options?: BuildPlaceBookingPayloadOptions
): PlaceBookingDto => ({
  users,
  bookingType: BookingType.WORKPLACE,
  locationInventoryId:
    options?.locationInventoryId !== undefined
      ? options.locationInventoryId
      : ctx.inputs.selectedLocation,
  automatedSeating: options?.automatedSeating ?? false,
  automatedSeatingObjects: ctx.inputs.automatedSeatingObjects,
  weekdays: ctx.inputs.weekdays,
  ...ctx.standardBookingInfo,
  ...ctx.standardBookingTimes
});

const getVisitorUsers = (usersBookedFor: TeamMember[] | undefined): TeamMember[] =>
  (usersBookedFor ?? []).slice(1).map(user => {
    const booksPlace = user.bookPlace === true;
    if (booksPlace) {
      return {
        ...user,
        isMobileWorking: false
      };
    }
    return {
      ...user,
      isMobileWorking: true,
      bookingInventoryId: undefined
    };
  });

const resolveVisitOnlyLocationInventoryId = (ctx: BookingStrategyContext): number | null => {
  const visitOnlyRegistration = ctx.inputs.visitorRegistrations?.find(
    registration => registration?.bookPlace !== true
  );
  const visitOnlyLocation = visitOnlyRegistration?.visitOnlySelectedLocation;
  if (visitOnlyLocation != null && !Number.isNaN(Number(visitOnlyLocation))) {
    return Number(visitOnlyLocation);
  }

  return ctx.inputs.selectedLocation;
};

export const visitorBookingStrategy = (ctx: BookingStrategyContext) => {
  const visitorUsers = getVisitorUsers(ctx.inputs.usersBookedFor);
  if (visitorUsers.length === 0) {
    ctx.onSuccess();
    return;
  }

  const payload = buildPlaceBookingPayload(ctx, visitorUsers, {
    automatedSeating: true,
    locationInventoryId: resolveVisitOnlyLocationInventoryId(ctx)
  });

  ctx.handlePromise(
    postVisitorGroupBooking(payload),
    () => {
      ctx.onSuccess();
      ctx.conferenceBookingUsers(
        ctx.conferenceInputs,
        ctx.inputs,
        ctx.conferenceBooking,
        ctx.sub,
        ctx.timezoneMobileWorking,
        ctx.onError
      );
    },
    ctx.onError
  );
};
